<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">{{ $t("Parâmetro") }}</h1>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-3 mb-4 p-2 shadow bg-white">
                    <div class="list-group">
                        <router-link
                            v-for="(tab, i) in tabs"
                            :key="i"
                            :to="{
                                name: 'admin.parametros',
                                params: { aba: tab.slug },
                            }"
                            :class="{ active: isAbaAtiva(tab) }"
                            class="list-group-item list-group-item-action"
                        >
                            {{ tab.title }}
                        </router-link>
                    </div>
                </div>
                <div class="col-md-9 pl-2 pr-0">
                    <div class="card shadow card-body tab-content">
                        <div
                            class="tab-pane animate__animated animate__fadeIn active"
                        >
                            <b-tabs content-class="mt-3">
                                <b-tab
                                    title="Tipo"
                                    v-if="
                                        model != 'RmaParametrizacao' &&
                                        modulo != 'Denuncia' &&
                                        model != 'Paf' &&
                                        model != 'ScfvGrupo' &&
                                        model != 'Referencia' &&
                                        model != 'ProgramaSocial' &&
                                        model != 'Acolhimento' &&
                                        model != 'ScfvGruposAtividade' &&
                                        model != 'FamiliaConfiguracao' &&
                                        model != 'TiposCompromisso' &&
                                        model != 'PainelGestor' &&
                                        model != 'ImportacaoConfiguracao' &&
                                        model != 'Agendamento' &&
                                        model != 'MotivosReagendamento'
                                    "
                                    active
                                >
                                    <Tipo
                                        :tipo="tipo"
                                        :modulo="modulo"
                                        :model="model"
                                    />
                                </b-tab>
                                <b-tab
                                    title="Status"
                                    v-if="
                                        model != 'RmaParametrizacao' &&
                                        model != 'Meta' &&
                                        model != 'Vulnerabilidade' &&
                                        model != 'Servico' &&
                                        model != 'FamiliaConfiguracao' &&
                                        model != 'TiposCompromisso' &&
                                        model != 'PainelGestor' &&
                                        model != 'ImportacaoConfiguracao' &&
                                        model != 'Agendamento' &&
                                        model != 'MotivosReagendamento'
                                    "
                                >
                                    <Status
                                        :tipo="tipo"
                                        :modulo="modulo"
                                        :model="model"
                                    />
                                </b-tab>

                                <b-tab
                                    title="Motivos"
                                    v-if="model == 'Acolhimento'"
                                >
                                    <MotivosAcolhimento
                                        :tipo="tipo"
                                        :modulo="modulo"
                                        :model="model"
                                    />
                                </b-tab>

                                <b-tab
                                    title="Configurações da família"
                                    v-if="model == 'FamiliaConfiguracao'"
                                >
                                    <FamiliaConfiguracao />
                                </b-tab>
                                <b-tab
                                    title="API SEPRO"
                                    v-if="model == 'FamiliaConfiguracao'"
                                >
                                    <ApiSepro />
                                </b-tab>
                                
                                <b-tab
                                    title="Tipo"
                                    v-if="model == 'TiposCompromisso'"
                                >
                                    <TiposCompromisso />
                                </b-tab>
                                <b-tab
                                  title="Tipo"
                                  v-if="model == 'MotivosReagendamento'"
                                >
                                    <MotivosReagendamento />
                                </b-tab>

                                <b-tab
                                    title="Parametrização RMA"
                                    v-if="model == 'RmaParametrizacao'"
                                    active
                                >
                                    <RmaParametrizacao />
                                </b-tab>

                                <b-tab title="Painel Gestor - BI" v-if="model == 'PainelGestor'">
                                    <PainelGestor  />
                                </b-tab>
                                <b-tab title="Parâmetros do Connected App" v-if="model == 'PainelGestor'" lazy>
                                    <ConnectedApp />
                                </b-tab>
                                <b-tab title="Agendamento" v-if="model == 'Agendamento'">
                                    <Agendamento />
                                </b-tab>
                                
                                <b-tab title="Importação" v-if="model == 'ImportacaoConfiguracao'" active>
                                    <ImportacaoConfiguracao />
                                </b-tab>
                            </b-tabs>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ImportacaoConfiguracao from "./includes/ImportacaoConfiguracao.vue";
import Tipo from "./includes/Tipo";
import Status from "./includes/Status";
import FamiliaConfiguracao from "./includes/FamiliaConfiguracao";
import ApiSepro from "./includes/ApiSepro.vue";
import TiposCompromisso from "./includes/TiposCompromisso.vue";
import MotivosAcolhimento from "./includes/MotivosAcolhimento.vue";

import MotivosReagendamento from "./includes/MotivosReagendamento.vue"
import RmaParametrizacao from "./includes/RmaParametrizacao.vue";
import PainelGestor from "./includes/painel_gestor_config.vue";
import ConnectedApp from "./includes/ConnectedApp.vue";
import Agendamento from "./includes/Agendamento.vue";

export default {
    components: { ImportacaoConfiguracao, Status,
                  Tipo, 
                  FamiliaConfiguracao, 
                  ApiSepro, 
                  TiposCompromisso, 
                  MotivosReagendamento, 
                  RmaParametrizacao,
                  PainelGestor,
                  ConnectedApp,
                  Agendamento,
                  MotivosAcolhimento },

    data() {
        return {
            tipo: "Acolhimento",
            modulo: "Acolhimento",
            model: "Acolhimento",
            tabs: [
                {
                    tipo: "Acolhimento",
                    modulo: "Acolhimento",
                    model: "Acolhimento",
                    title: "Acolhimento",
                    slug: "acolhimento",
                },
                {
                    tipo: "Atendimento",
                    modulo: "Atendimento",
                    model: "Atendimento",
                    title: "Atendimento",
                    slug: "atendimento",
                },
                {
                    tipo: "TiposCompromisso",
                    modulo: "TiposCompromisso",
                    model: "TiposCompromisso",
                    title: "Tipos de Compromissos (Agenda Ativa)",
                    slug: "tipos-compromisso",
                },
                {
                    tipo: "MotivosReagendamento",
                    modulo: "MotivosReagendamento",
                    model: "MotivosReagendamento",
                    title: "Motivos de Reagendamento (Agenda Ativa)",
                    slug: "motivos-reagendamento",
                },
                {
                    tipo: "Beneficio",
                    modulo: "Beneficio",
                    model: "Beneficio",
                    title: "Benefício",
                    slug: "beneficio",
                },
                {
                    tipo: "Encaminhamento",
                    modulo: "Encaminhamento",
                    model: "Encaminhamento",
                    title: "Encaminhamento",
                    slug: "encaminhamento",
                },
                {
                    tipo: "FamiliaConfiguracao",
                    modulo: "FamiliaConfiguracao",
                    model: "FamiliaConfiguracao",
                    title: "Configuração da Família",
                    slug: "familia-configuracao",
                },
                {
                    tipo: "Referência e Contrareferência",
                    modulo: "Referencia",
                    model: "Referencia",
                    title: "Referência e Contrareferência",
                    slug: "referencia",
                },
                {
                    tipo: "Violência e Violação de Direitos",
                    modulo: "ViolenciaViolacaoDireito",
                    model: "ViolenciaViolacaoDireito",
                    title: "Violência e Violação de Direitos",
                    slug: "violencia-violacao-direito",
                },
                {
                    tipo: "Grupos SCFV",
                    modulo: "Scfv",
                    model: "ScfvGrupo",
                    title: "SCFV",
                    slug: "scfv",
                },
                {
                    tipo: "Atividades de Grupos do SCFV",
                    modulo: "Scfv",
                    model: "ScfvGruposAtividade",
                    title: "SCFV Atividade",
                    slug: "scfv-atividade",
                },
                {
                    tipo: "Vulnerabilidades",
                    modulo: "Configuracao",
                    model: "Vulnerabilidade",
                    title: "Vulnerabilidade",
                    slug: "vulnerabilidade",
                },
                {
                    tipo: "Paf",
                    modulo: "PAF",
                    model: "Paf",
                    title: "PAF",
                    slug: "paf",
                },
                {
                    tipo: "Metas",
                    modulo: "Configuracao",
                    model: "Meta",
                    title: "Meta",
                    slug: "meta",
                },
                {
                    tipo: "Medidas Socioeducativas",
                    modulo: "Medidas",
                    model: "MedidasSocioeducativa",
                    title: "Medida Socioeducativa",
                    slug: "medida-socioeducativa",
                },
                {
                    tipo: "Programas Sociais",
                    modulo: "ProgramaSocial",
                    model: "ProgramaSocial",
                    title: "Programa Social",
                    slug: "programa-social",
                },
                {
                    tipo: "Ofícios",
                    modulo: "Oficio",
                    model: "Oficio",
                    title: "Ofício",
                    slug: "oficio",
                },
                {
                    tipo: "Denúncias",
                    modulo: "Denuncia",
                    model: "Denuncia",
                    title: "Denúncia",
                    slug: "denuncia",
                },
                {
                    tipo: "Atividades",
                    modulo: "Atividade",
                    model: "Atividade",
                    title: "Atividade",
                    slug: "atividade",
                },
                {
                    tipo: "Serviço",
                    modulo: "Servico",
                    model: "Servico",
                    title: "Serviço",
                    slug: "servico",
                },
                {
                    tipo: "Unidade",
                    modulo: "Unidade",
                    model: "Unidade",
                    title: "Unidade",
                    slug: "unidade",
                },
                {
                    tipo: "RMA",
                    modulo: "Rma",
                    model: "RmaParametrizacao",
                    title: "RMA",
                    slug: "rma",
                },
                {
                    tipo: "Painel Gestor - BI",
                    modulo: "PainelGestor",
                    model: "PainelGestor",
                    title: "Painel Gestor - BI",
                    slug: "painel-gestor-bi",
                },
                {
                    tipo: "Importação",
                    modulo: "Importacao",
                    model: "ImportacaoConfiguracao",
                    title: "Importação",
                    slug: "importacao",
                },
                {
                    tipo: "Agendamento",
                    modulo: "Agendamento",
                    model: "Agendamento",
                    title: "Agendamento",
                    slug: "agendamento",
                },
            ],
        };
    },

    watch: {
        '$route.params.aba': {
            immediate: true,
            handler(aba) {
                this.definirAbaPelaUrl(aba);
            },
        },
    },

    methods: {
        isAbaAtiva(tab) {
            return this.model === tab.model;
        },

        definirAbaPelaUrl(aba) {
            const abaPadrao = this.tabs[0].slug;
            const slug = aba || abaPadrao;
            const tab = this.tabs.find((item) => item.slug === slug);

            if (!tab) {
                this.aplicarAba(this.tabs[0]);
                this.redirecionarParaAbaPadrao(abaPadrao);
                return;
            }

            this.aplicarAba(tab);

            if (!aba) {
                this.redirecionarParaAbaPadrao(abaPadrao);
            }
        },

        aplicarAba(tab) {
            this.tipo = tab.tipo;
            this.modulo = tab.modulo;
            this.model = tab.model;
        },

        redirecionarParaAbaPadrao(abaPadrao) {
            this.$router
                .replace({
                    name: 'admin.parametros',
                    params: { aba: abaPadrao },
                })
                .catch(this.ignorarNavigationDuplicated);
        },

        ignorarNavigationDuplicated(error) {
            if (error && error.name !== 'NavigationDuplicated') {
                throw error;
            }
        },
    },
};
</script>
<style lang="css">
.list-group-item-action {
    cursor: pointer;
}
</style>
